module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/uzemniPlanovani@3x-9ff3abab4ba1d131f7f2bf59a5bc8d6c.png";